import { Component, AfterContentInit, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { getSimpleIdentifierFromString } from '../../api/plyca-dtos';
import { Configuration } from '../../conf/app.constants';
import { ContractModificationConfigurationDTO } from '../../api/plyca-dtos-v2';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { UserService } from '../../user.service';

@Component({
  selector: 'contractModificationTypes',
  templateUrl: 'contractModificationTypes.template.html'
})
export class contractModificationTypesComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  showHeader = true;
  loading = false;
  types: ContractModificationConfigurationDTO[];
  contractId: string;
  isProjectReplyca: boolean;
  activeContractModificationReplyca = false;


  constructor(
    private plycaService: PlycaDataService,
    public configuration: Configuration,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private appConfig: AppConfiguration,
    public userService: UserService,
  ) {
    super();
    this.contractId = this.dialogConfig['contractId'];
    this.isProjectReplyca = this.dialogConfig['isProjectReplyca'];
    let newContractModificationReplycaProfiles = appConfig.getValue('contractModificationReplyca.profiles');
    this.activeContractModificationReplyca = this.userService.hasRoles(newContractModificationReplycaProfiles, 'RECO');
    //this.activeContractModificationReplyca = appConfig.getValue('contractModificationReplyca.enabled');
  }

  ngAfterContentInit(): void {
    if (this.isProjectReplyca && !this.activeContractModificationReplyca) {
      this.loadDataRegister();
    } else {
      this.loadData();
    }
  }

  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }

  //El mismo código de loadData pero con una URL diferente.
  //Si se lleva a alguna clase de adaptacion, sería este metodo...
  loadDataRegister() {
    this.loading = true;
    this.subscribe(this.plycaService
      .query<ContractModificationConfigurationDTO>(
        this.configuration.REGISTER_CONTRACT_MODIFICATIONS_TYPES_SERVICE_URL, {
        contractId: this.contractId,
      }
      ),
      (datos: any) => {
        this.types = [];
        datos.content
          .forEach(element => {
            //if (element.available)
            this.types.push(element);
          });

        //this.types = datos.content;
        this.types.sort((a, b) =>
          a.contractModificationType.description.toLowerCase() < b.contractModificationType.description.toLowerCase()
            ? -1
            : a.contractModificationType.description.toLowerCase() > b.contractModificationType.description.toLowerCase()
              ? 1
              : 0
        );
        this.loading = false;
      });
  }

  loadData() {
    this.loading = true;
    this.subscribe(this.plycaService
      .query<ContractModificationConfigurationDTO>(
        this.configuration.CONTRACT_MODIFICATIONS_TYPES_SERVICE_URL, {
        contractId: this.contractId,
      }
      ),
      (datos: any) => {
        this.types = [];
        if (datos != null && datos.content) {
        datos.content
          .forEach(element => {
            this.types.push(element);
          });



        //this.types = datos.content;
        this.types.sort((a, b) =>
          a.contractModificationType.description.toLowerCase() < b.contractModificationType.description.toLowerCase()
            ? -1
            : a.contractModificationType.description.toLowerCase() > b.contractModificationType.description.toLowerCase()
              ? 1
              : 0
        );
      }
      this.loading = false;
    }
    );
  }

  isLoading(): boolean {
    return this.loading;
  }

  cancel(): void {
    this.ref.close();
  }

  selectType(type: ContractModificationConfigurationDTO) {
    if (type.contractModificationType) {
      console.log('Type',
      );
      //this.ref.close(type['properties']['INCIDENCIA_ALIAS']);
      this.ref.close(getSimpleIdentifierFromString(type.contractModificationType.identifier));
    }
  }

  // public updateFilter() {
  //   let val: string = this.filterText;
  //   this.filteredReportList = this.reportList.filter(function(d: any) {
  //     let reportDesc = d.name;
  //     return reportDesc.toLowerCase().indexOf(val.toLowerCase()) !== -1 || !val;
  //   });

  // }
}
